import { render, staticRenderFns } from "./AddCif.vue?vue&type=template&id=446f6c95"
import script from "./AddCif.vue?vue&type=script&lang=js"
export * from "./AddCif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports